import { theme } from "@clearabee/ui-library-base";
import React, { useEffect, useRef } from "react";
import { View, Animated, Easing } from "react-native";
import { Icon } from "../Icon/Icon";
import { Text } from "../Text/Text";
import { styles } from "./Loader.styles";
export const Loader = ({ color = "light", text, styles: userStyles, }) => {
    const animationValue = useRef(new Animated.Value(0)).current;
    const spin = animationValue.interpolate({
        inputRange: [0, 1],
        outputRange: ["0deg", "360deg"],
    });
    useEffect(() => {
        Animated.loop(Animated.timing(animationValue, {
            toValue: 1,
            duration: 10000,
            easing: Easing.linear,
            useNativeDriver: true,
        })).start();
    }, [animationValue]);
    return (React.createElement(View, { style: [styles[color], userStyles] },
        React.createElement(View, { style: [styles.loader] },
            React.createElement(Icon.DottedCircle, { color: color, width: 125, height: 118 }),
            React.createElement(Animated.View, { style: [
                    styles.beeLogo,
                    {
                        transform: [
                            { rotate: spin },
                            { translateX: 57 },
                            { rotate: "110deg" },
                        ],
                    },
                ] },
                React.createElement(Icon.Bee, { size: "large", color: color }))),
        React.createElement(Text, { styles: [styles.text, { color: theme.colors[color].base }] }, text)));
};
//# sourceMappingURL=Loader.js.map